import { render, staticRenderFns } from "./ClassicSelect.vue?vue&type=template&id=379f2b2e&scoped=true&"
import script from "./ClassicSelect.vue?vue&type=script&lang=js&"
export * from "./ClassicSelect.vue?vue&type=script&lang=js&"
import style0 from "./ClassicSelect.vue?vue&type=style&index=0&id=379f2b2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379f2b2e",
  null
  
)

export default component.exports